/**
 * ECOBAG GIFT v7 — auto-add (preço R$ 0 nativo, sem cupom)
 *
 * Ecobag Guday Club (variant 52872697938229) tem price=R$0 / compareAtPrice=R$39,90
 * no admin. Este JS apenas garante que ela esteja no cart quando subtotal >= R$279.
 *
 * Sem aplicação de discount code: a economia visual (preço riscado) vem direto do
 * compareAtPrice nativo do Shopify. Empilha com MONTAQUEDESCONTA10/15 sem conflito.
 *
 * Detecção: fetch interception (funciona com Kaching, theme nativo, etc).
 * Requests próprias marcadas com X-Ecobag-Gift pra não disparar loop.
 */
(function () {
  'use strict';

  var ECOBAG_VARIANT_ID = 52872697938229;
  var GIFT_PROPERTY_KEY = '_ecobag_gift';
  var MIN_SUBTOTAL = 27900; // R$279 in cents
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var OWN_REQUEST_HEADER = 'X-Ecobag-Gift';

  var isProcessing = false;
  var debounceTimer = null;
  var cachedCart = null;
  var bannerEl = null;

  // Captura fetch ANTES dos interceptors de apps. Fallback pra __originalFetch.
  var nativeFetch = (window.__originalFetch && window.__originalFetch.bind(window))
    || window.fetch.bind(window);

  // ── Helpers ──────────────────────────────────────────────────────────

  function getCart() {
    return nativeFetch(ROOT + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function ecobagGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.variant_id === ECOBAG_VARIANT_ID &&
          item.properties &&
          item.properties[GIFT_PROPERTY_KEY] === 'true') {
        return { line: i + 1, item: item };
      }
    }
    return null;
  }

  // Retorna TODAS as linhas da ecobag (com ou sem property). Usado pra detectar
  // duplicação: cliente que aumentou qty no drawer ou adicionou pela PDP avulsa.
  function ecobagAllLines(cart) {
    var lines = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.variant_id === ECOBAG_VARIANT_ID) {
        lines.push({ line: i + 1, item: item });
      }
    }
    return lines;
  }

  function subtotalExcludingGift(cart) {
    var subtotal = 0;
    cart.items.forEach(function (item) {
      // Exclui QUALQUER ecobag (com ou sem property) — preço já é R$0 mesmo,
      // mas garantir consistência se algum dia preço mudar.
      if (item.variant_id === ECOBAG_VARIANT_ID) return;
      subtotal += item.price * item.quantity;
    });
    return subtotal;
  }

  // ── Actions ──────────────────────────────────────────────────────────

  function addEcobag() {
    return nativeFetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Ecobag-Gift': '1'
      },
      body: JSON.stringify({
        items: [{
          id: ECOBAG_VARIANT_ID,
          quantity: 1,
          properties: { _ecobag_gift: 'true' }
        }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Add ecobag failed: ' + r.status);
      return r.json();
    });
  }

  function removeEcobag(line) {
    return nativeFetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Ecobag-Gift': '1'
      },
      body: JSON.stringify({ line: line, quantity: 0 })
    });
  }

  function refreshDrawer() {
    if (window.kachingCartApi && window.kachingCartApi.refreshCart) {
      try { window.kachingCartApi.refreshCart(); } catch (e) {}
    }
  }

  // ── Banner (feedback visual sem bloquear cliques) ────────────────────

  function ensureBannerStyles() {
    if (document.getElementById('ecobag-banner-style')) return;
    var style = document.createElement('style');
    style.id = 'ecobag-banner-style';
    style.textContent =
      '.ecobag-banner{position:fixed;top:0;left:0;right:0;z-index:100001;pointer-events:none;display:flex;justify-content:center;padding:12px 16px;transform:translateY(-100%);transition:transform .2s ease}' +
      '.ecobag-banner.is-visible{transform:translateY(0)}' +
      '.ecobag-banner__box{background:#171717;color:#fff;padding:10px 18px;border-radius:999px;box-shadow:0 4px 16px rgba(0,0,0,.18);display:flex;align-items:center;gap:10px;font-family:inherit;font-size:13px;font-weight:500;max-width:calc(100vw - 32px)}' +
      '.ecobag-banner__spin{width:14px;height:14px;border:2px solid rgba(255,255,255,.25);border-top-color:#fff;border-radius:50%;animation:ecobag-spin .7s linear infinite;flex-shrink:0}' +
      '@keyframes ecobag-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
  }

  function showBanner(text) {
    ensureBannerStyles();
    if (!bannerEl) {
      bannerEl = document.createElement('div');
      bannerEl.className = 'ecobag-banner';
      bannerEl.innerHTML = '<div class="ecobag-banner__box"><span class="ecobag-banner__spin"></span><span class="ecobag-banner__text"></span></div>';
      document.body.appendChild(bannerEl);
    }
    bannerEl.querySelector('.ecobag-banner__text').textContent = text;
    bannerEl.offsetHeight; // reflow pra animação
    bannerEl.classList.add('is-visible');
  }

  // ── Disable qty controls on ecobag rows ──────────────────────────────
  // Cliente não deve poder alterar a quantidade da ecobag (sempre qty=1).
  // Estratégia: localiza o <a href="/products/ecobag-guday-club"> de cada
  // line item, sobe no DOM e marca APENAS o container do +/− qty (input +
  // 2 botões irmãos). Mantém visível mas com pointer-events:none + opacity.

  var ECOBAG_HANDLE = 'ecobag-guday-club';
  var qtyDisableObserver = null;

  function ensureQtyDisableStyles() {
    if (document.getElementById('ecobag-qty-disable-style')) return;
    var style = document.createElement('style');
    style.id = 'ecobag-qty-disable-style';
    style.textContent =
      '[data-ecobag-qty-locked]{pointer-events:none!important;opacity:.4!important;cursor:not-allowed!important}' +
      '[data-ecobag-qty-locked] *{cursor:not-allowed!important;user-select:none}';
    document.head.appendChild(style);
  }

  // A partir do link da ecobag, sobe no DOM (max 6 níveis) procurando o
  // container que tem EXATAMENTE 1 input de qty + 2 botões irmãos. Esse é
  // o widget +/- da linha — e só ele é marcado, isolando do resto da UI.
  function findQtyContainerNear(linkEl) {
    var el = linkEl;
    for (var i = 0; i < 6 && el; i++) {
      var inputs = el.querySelectorAll('input[type="number"], input[inputmode="numeric"], input[role="spinbutton"]');
      if (inputs.length === 1) {
        var input = inputs[0];
        var qtyParent = input.parentElement;
        if (qtyParent) {
          var siblingBtns = qtyParent.querySelectorAll(':scope > button');
          if (siblingBtns.length === 2) {
            return qtyParent;
          }
          // Fallback: alguns drawers envolvem cada botão num span — checa
          // botões a até 1 nível dos filhos diretos.
          var allBtns = qtyParent.querySelectorAll('button');
          if (allBtns.length === 2) {
            return qtyParent;
          }
        }
      }
      el = el.parentElement;
    }
    return null;
  }

  function lockEcobagRows() {
    ensureQtyDisableStyles();
    var links = document.querySelectorAll(
      'a[href*="/products/' + ECOBAG_HANDLE + '"]'
    );
    for (var i = 0; i < links.length; i++) {
      var qtyContainer = findQtyContainerNear(links[i]);
      if (qtyContainer && !qtyContainer.hasAttribute('data-ecobag-qty-locked')) {
        qtyContainer.setAttribute('data-ecobag-qty-locked', '1');
      }
    }
  }

  function installQtyDisableObserver() {
    if (qtyDisableObserver) return;
    lockEcobagRows();
    qtyDisableObserver = new MutationObserver(function () {
      if (qtyDisableObserver._pending) return;
      qtyDisableObserver._pending = true;
      requestAnimationFrame(function () {
        qtyDisableObserver._pending = false;
        lockEcobagRows();
      });
    });
    qtyDisableObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function hideBanner() {
    if (!bannerEl) return;
    bannerEl.classList.remove('is-visible');
  }

  // ── Core ─────────────────────────────────────────────────────────────

  function autoTriggerIfEligible() {
    if (isProcessing) return Promise.resolve();

    var cartPromise = cachedCart ? Promise.resolve(cachedCart) : getCart();
    cachedCart = null;

    return cartPromise.then(function (cart) {
      var subtotal = subtotalExcludingGift(cart);
      var allEcobagLines = ecobagAllLines(cart);
      var giftLine = ecobagGiftLine(cart);

      var needsAdd = subtotal >= MIN_SUBTOTAL && allEcobagLines.length === 0;
      var needsRemove = subtotal < MIN_SUBTOTAL && allEcobagLines.length > 0;

      // Detecta duplicação/qty>1: cliente subiu qty no drawer OU adicionou
      // avulsa pela PDP (linha sem property) + auto-add já tinha posto a com
      // property. Resolve: deixa só 1 linha com qty=1.
      var needsDedupe = false;
      if (subtotal >= MIN_SUBTOTAL && !needsAdd) {
        // Casos: várias linhas, ou uma linha com qty > 1
        if (allEcobagLines.length > 1) needsDedupe = true;
        else if (allEcobagLines[0] && allEcobagLines[0].item.quantity > 1) needsDedupe = true;
      }

      if (!needsAdd && !needsRemove && !needsDedupe) return;

      isProcessing = true;
      if (needsAdd) showBanner('🎁 Adicionando um brinde gratuito...');

      if (needsAdd) {
        return addEcobag().then(refreshDrawer);
      }

      if (needsRemove) {
        // Remove TODAS as ecobags (com ou sem property). Itera de trás pra
        // frente pra que os índices das linhas anteriores não mudem.
        var sorted = allEcobagLines.slice().sort(function (a, b) {
          return b.line - a.line;
        });
        var chain = Promise.resolve();
        sorted.forEach(function (l) {
          chain = chain.then(function () { return removeEcobag(l.line); });
        });
        return chain.then(refreshDrawer);
      }

      // needsDedupe — manter só 1 ecobag, com property, qty=1.
      // Estratégia: remove TODAS de trás pra frente, depois adiciona 1 limpa.
      var sortedDup = allEcobagLines.slice().sort(function (a, b) {
        return b.line - a.line;
      });
      var dedupeChain = Promise.resolve();
      sortedDup.forEach(function (l) {
        dedupeChain = dedupeChain.then(function () { return removeEcobag(l.line); });
      });
      return dedupeChain
        .then(function () { return addEcobag(); })
        .then(refreshDrawer);
    }).catch(function () {
      // silencioso — falha de rede não deve quebrar nada
    }).then(function () {
      hideBanner();
      isProcessing = false;
    });
  }

  function debouncedTrigger() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(autoTriggerIfEligible, 100);
  }

  // ── Fetch interception ───────────────────────────────────────────────

  function isOwnRequest(init) {
    if (!init || !init.headers) return false;
    if (init.headers instanceof Headers) {
      return init.headers.has(OWN_REQUEST_HEADER);
    }
    return !!init.headers[OWN_REQUEST_HEADER];
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update)\.js/.test(url);
  }

  function installFetchInterceptor() {
    var prev = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string'
        ? input
        : (input && input.url ? input.url : '');

      var result = prev.apply(this, arguments);

      if (url && isCartMutation(url) && !isOwnRequest(init)) {
        result.then(function (r) {
          if (r && r.clone) {
            r.clone().json().then(function (cart) {
              if (cart && cart.items) cachedCart = cart;
            }).catch(function () {});
          }
          debouncedTrigger();
        }).catch(function () {});
      }

      return result;
    };
  }

  // ── Init ─────────────────────────────────────────────────────────────

  function init() {
    installFetchInterceptor();
    installQtyDisableObserver();
    setTimeout(autoTriggerIfEligible, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
